<template>
  <modal name="admin-question" height="auto" width="390px" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('admin-question')"  alt="">
    </div>
    <div class="modal-form">
      <h4 class="title">Вопрос</h4>
      <div class="input-block">
          <textarea
                  type="text"
                  v-model="text"
                  name="text"
                  data-vv-validate-on="blur"
                  data-vv-as="Вопрос"
                  v-validate="'required'"
          >
            </textarea>
        <span class="text-danger text-sm">{{ errors.first('text') }}</span>
      </div>
      <div class="add_file" v-if="!file" @click="fileInput">
        <img src="../../assets/icons/chat/paperclip.svg" alt=""> Прикрепить файл
      </div>
      <div v-if="file">
        {{file.name}} <img class="hover_btn delete_file" @click="deleteFile()" src="@/assets/img/worker/delete.svg" alt="">
      </div>
      <input type="file" model="select_file" ref="file" hidden @change="onFileChange">
      <br>
      <div class="btn">
        <button @click="save()">Отправить</button>
      </div>
    </div>
  </modal>
</template>

<script>

export default {
  name: "admin-question-modal",
  data: ()=> ({
    text: '',
    file: ''
  }),
  methods: {
    open(){
      this.$modal.show('admin-question')
    },
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    fileInput() {
      this.$refs.file.click();
    },
    deleteFile() {
      this.file = '';
      this.$refs.file.value = null;
    },
    save() {
      this.$validator.validateAll()
        .then(success => {
          if(success){
            let formData = new FormData();
            if (this.file) {
              formData.append('file', this.file);
            }
            formData.append('text', this.text);
            formData.append('token', localStorage.getItem('token'));
            this.$http.post('/admin-question', formData,
                    {
                      headers: {
                        'Content-Type': 'multipart/form-data'
                      }
                    }
            ).then(({data}) => {
              if (data.success) {
                this.$toast.success('Вопрос отправлен!');
              }
            }).catch(() => {
                this.$toast.error('Ошибка!');
            })

            this.$modal.hide('admin-question');
            this.text = '';
            this.$refs.file.value = null;
            this.file = '';
          }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}

.delete_file {
  margin: -5px 0px 0px 20px;
  cursor: pointer;
}

.add_file {
  cursor: pointer;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
textarea{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 140px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>